import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/OnboardingWizard/result/ResultIdleCashHeroValue";
import type { FC } from "react";

const I18n = I18nUtil.createScoped(Translations);

const IDLE_CASH_AMOUNT_PATTERN = /^(\+\$[\d,]+)(?:\/?yr)?$/i;

export function parseIdleCashHeroAmount(value: string): string | null {
  const match = value.match(IDLE_CASH_AMOUNT_PATTERN);
  return match?.[1] ?? null;
}

interface ResultIdleCashHeroValueProps {
  value: string;
}

/** Figma 96138:32120 — display_s amount + title_xxl "/yr" on shared baseline. */
export const ResultIdleCashHeroValue: FC<ResultIdleCashHeroValueProps> = ({
  value,
}) => {
  const amount = parseIdleCashHeroAmount(value);

  if (!amount) {
    return (
      <span
        className="display_s text-content_primary"
        data-testid="result-idle-cash-hero-value"
      >
        {value}
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-end gap-1"
      data-testid="result-idle-cash-hero-value"
    >
      <span className="display_s text-content_primary">{amount}</span>
      <span className="title_xxl text-content_primary">{I18n.t("/yr")}</span>
    </span>
  );
};
